import { render, staticRenderFns } from "./ChartersEdit.vue?vue&type=template&id=5710e7c2&"
import script from "./ChartersEdit.vue?vue&type=script&lang=js&"
export * from "./ChartersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports